export default __webpack_public_path__ + "static/media/SFProDisplay-Regular.d5ff9f68.woff2";